import React, { useRef } from 'react';
import ContactForm from '../ContactForm';  // Import the ContactForm
import logoSrc from '../img/logo.png'; // Assuming the logo image is in the img folder

const Marketing = () => {
  const contactFormRef = useRef(); // Reference for controlling the contact form

  // Function to open the contact form
  const handleOpenContactForm = () => {
    if (contactFormRef.current) {
      contactFormRef.current.openForm(); // Ensure the `ContactForm` has this method.
    }
  };

  return (
    <>
      {/* Hero Section */}
      <div className="banner-logo" id="sectionBanner1">
        {logoSrc && <img src={logoSrc} alt="Shigjeta Logo" />}
      </div>

      <section className="banner-section" id="sectionBanner">
        <div className="banner-container">
          {/* Left Side Content */}
          <div className="banner-text">
            <h1 className="banner-title">achieve objectives with strategy</h1>
            <p className="banner-description">
              Build robust marketing solutions with Shigjeta’s development expertise. From platform integrations to analytics tools, we empower your brand with cutting-edge technology.
            </p>
            <a
              onClick={handleOpenContactForm} // Open the form on button click
              className="banner-button"
            >
              Start Now
            </a>
          </div>
        </div>
      </section>

      {/* Background Image */}
      <div className="img-background">
        <img
          className="img"
          id="banner1-video"
          src="/img/Main Services Thumbnail.png"
          alt="Thumbnail"
          autoPlay
          muted
          loop
          playsInline
          onError={(e) => console.error('Error loading image:', e)} // Error logging for debugging
        />
      </div>

      {/* Marketing Automation Section */}
      <section className="about-section">
        <div className="about-row">
          <div className="about-text">
            <h2><strong>Marketing Automation</strong></h2>
            <p>Automate your workflows and campaigns to save time and maximize efficiency. We implement tools like HubSpot, Mailchimp, and custom solutions.</p>
            <ul>
              <li><strong>CRM Integration:</strong> Connect with platforms like Salesforce and HubSpot.</li>
              <li><strong>Email Automation:</strong> Streamline personalized messaging.</li>
              <li><strong>Workflow Automation:</strong> Custom rules and triggers.</li>
              <li><strong>Analytics Integration:</strong> Real-time performance tracking.</li>
            </ul>
          </div>
          <div className="about-image">
            <img src="/img/m2.1.png" alt="Marketing Automation" />
          </div>
        </div>

        {/* Web Development for Marketing Section */}
        <div className="about-row reverse">
          <div className="about-text">
            <h2><strong>Web Development for Marketing</strong></h2>
            <p>From landing pages to custom websites, we design and develop digital assets optimized for performance and conversions.</p>
            <ul>
              <li><strong>Landing Pages:</strong> High-converting pages for campaigns.</li>
              <li><strong>Custom Websites:</strong> Tailored for your marketing goals.</li>
              <li><strong>Optimization:</strong> Fast, responsive, and SEO-ready builds.</li>
              <li><strong>Integrations:</strong> Connect with CMS, CRMs, and analytics tools.</li>
            </ul>
          </div>
          <div className="about-image">
            <img src="/img/m2.2.png" alt="Web Development for Marketing" />
          </div>
        </div>

        {/* Analytics and Performance Section */}
        <div className="about-row">
          <div className="about-text">
            <h2><strong>Strong on Social Media</strong></h2>
            <p>Unlock insights with analytics tools and ensure your campaigns deliver measurable success.</p>
            <ul>
              <li><strong>Facebook and Instagram:</strong> Monitor traffic and optimize content to boost engagement and growth.</li>
              <li><strong>Tiktok and Youtube:</strong> Track campaigns in real time and maximize reach with creative videos.</li>
              <li><strong>LinkedIn and Twitter:</strong> Use data insights to craft professional content and drive conversations.</li>
              <li><strong>Reddit and Pinterest:</strong> Optimize engagement by tailoring strategies to unique audience preferences.</li>
            </ul>
          </div>
          <div className="about-image">
            <img src="/img/m2.3.png" alt="Analytics & Performance" />
          </div>
        </div>

        {/* Development Success Stories Section */}
        <div className="about-row reverse">
          <div className="about-text">
            <h2><strong>Development Success Stories</strong></h2>
            <p>Explore how our development solutions have transformed businesses through automation, analytics, and optimized platforms.</p>
            <a href='/blog' className="cta-button">Read Our Case Studies</a>
          </div>
          <div className="about-image">
            <img src="/img/m2.4.png" alt="Development Success Stories" />
          </div>
        </div>
      </section>

      {/* Render the ContactForm component and pass the ref */}
      <ContactForm ref={contactFormRef} />
    </>
  );
};

export default Marketing;
